const panelsDefaultState = {
    account: 'info',
    foodItem: 'info',
    pizza: 'info',
    special: 'info',
    cart: 'info',
    history: 'list'
};

export default (state = panelsDefaultState, action) => {
    switch (action.type) {

        case 'SET_ACCOUNT_PANEL':
            return {
                ...state,
                account: action.panel
            };

        case 'SET_FOOD_ITEM_PANEL':
            return {
                ...state,
                foodItem: action.panel
            };

        case 'SET_PIZZA_PANEL':
            return {
                ...state,
                pizza: action.panel
            };

        case 'SET_SPECIAL_PANEL':
            return {
                ...state,
                special: action.panel
            };

        case 'SET_CART_PANEL':
            return {
                ...state,
                cart: action.panel
            };

        case 'SET_HISTORY_PANEL':
            return {
                ...state,
                history: action.panel
            };

        case 'RESET_PANELS':
            return panelsDefaultState;

        default:
            return state;
    }
};